const FixtureGetSubscriptionsByIdActive = {
  success: {},
  payload: {
    subscription: {
      id: { id: "TEST-ID-ACTIVE" },
      user_id: { id: "5e0b13e5-aa4c-484d-97fe-de52eaff7177" },
      status: "ACTIVE",
      next_billing_date: "2024-04-15T10:00:00.863710Z",
      last_billing_date: null,
      start_date: "2022-01-10T11:14:01.863710Z",
      expiration_date: null,
      cancellation_cause: "UNKNOWN",
      created_at: "2022-01-10T11:14:01.863710Z",
      updated_at: null,
      recurly_subscription_id: "a",
      stripe_subscription_id: "",
      activated_at: null,
      cancellation_date: null,
      device_sns: ["N1-605944813"],
      internal_id: null,
      coupon_codes: [],
      subscription_quantity: 1,
      prepaid_period_days: 60,
      trial_period_days: 30,
      subscription_type: "STANDARD_SUBSCRIPTION",
    },
  },
};
export default FixtureGetSubscriptionsByIdActive;
